import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/fanhearts.com/fanhearts.com/src/app/notice/[id]/_components/NoticeDetail.tsx");
